// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1AXbL","title":"BackImages_title__2PdoK","images":"BackImages_images__1JT2E"};